import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.containerTarget.addEventListener("trix-initialize", () => {
      this.updateHeadingOneButton()
      this.addHeadingButton("2")
    })
  }

  updateHeadingOneButton() {
    let toolbar = this.containerTarget.querySelector("[id^='trix-toolbar-']")
    let headingOneButton = toolbar.querySelector("button.trix-button--icon-heading-1")
    headingOneButton.innerText = "Heading 1"
    headingOneButton.setAttribute("title", "Heading 1")
  }

  addHeadingButton(heading) {
    const newButton = document.createElement("button")
    newButton.innerText = `Heading ${heading}`
    newButton.setAttribute("type", "button")
    newButton.setAttribute("class", `trix-button trix-button--icon trix-button--icon-heading-${heading}`)
    newButton.setAttribute("data-trix-attribute", `heading${heading}`)
    newButton.setAttribute("title", `Heading ${heading}`)
    newButton.setAttribute("tabindex", "-1")
    newButton.setAttribute("data-trix-active", "")

    let toolbar = this.containerTarget.querySelector("[id^='trix-toolbar-']")
    let quoteButton = toolbar.querySelector("button.trix-button--icon-quote")
    quoteButton.parentNode.insertBefore(newButton, quoteButton)
  }
}
